<script>
  import Vue from 'vue/dist/vue.esm'
  import Scrollspy, { Easing } from 'vue2-scrollspy'

  Vue.use(Scrollspy, {
    easing: Easing.Cubic.Out
  })

  export default {
    mounted() {
      window.addEventListener('scroll', this.scrolled)
      this.scrolled()
    },
    methods: {
      toggleMenu() {
        const menuClosed = document.getElementById('menuClosed')
        const menuOpened = document.getElementById('menuOpened')
        const nav = document.getElementById('nav-xs')
        if (nav.classList.contains('hidden')) {
          nav.classList.remove('hidden')
          menuOpened.classList.remove('hidden')
          menuClosed.classList.add('hidden')
        } else {
          nav.classList.add('hidden')
          menuOpened.classList.add('hidden')
          menuClosed.classList.remove('hidden')
        }
      },
      scrolled() {
        const header = document.getElementById('header-lg')
        if (!header) return
        if (document.body.classList.contains('header-picture-enabled')) {
          header.classList.remove('shadow-lg')
        } else {
          if (window.scrollY === 0) {
            header.classList.remove('shadow-lg')
          } else {
            header.classList.add('shadow-lg')
          }
        }
      }
    }
  }
</script>
